module.exports = __webpack_public_path__ + "img/back pocket bag height.80f26bda.png";